import React, { useState, useEffect } from 'react';
import { GenericList } from '../../builders/list';
import { Footer } from '../../components';
import axios from 'axios';

export default function ListAdministrators({ consumer, entity, history }) {
  const [elements, setElements] = useState([]);
  const [messages, setMessages] = useState({});
  const [config, setConfig] = useState({});
  const [preloader, setPreloader] = useState(true);

  async function configTable() {
    const response = await fetch('./preferences.json');

    const { tables } = await response.json();

    setConfig(tables.administrators);
  }

  async function getProfiles() {
    const { data } = await axios.get('http://localhost:3333/administrators');

    const tempStructure = {
      result: data,
      current_page: 1,
      page_count: 1,
      page_size: data.length,
      row_count: data.length,
    };

    setMessages({
      noContent: data.length == 0 ? 'Nenhum perfil cadastrado' : null,
    });

    setElements(tempStructure);
    setPreloader(false);
  }

  useEffect(() => {
    configTable();
    getProfiles();

    consumer.defineRoute({ name: 'Administrators', uri: '/administrators' });
  }, []);

  function handleMultiDelete(uid) {
    //DELETE PROFILE ENDPOINT
  }
  function onUpdate(uid) {
    history.push(`administrators/${uid}`);
  }

  return (
    <>
      <GenericList
        consumer={consumer}
        elements={elements}
        messages={messages}
        fields={config.fields}
        options={config.options}
        breadcrumb={{
          selectOptions: null,
          routeNew: '/administrators/new',
          label: entity,
          customNewOptionTitle: 'New Administrator',
        }}
        loading={{
          preloader,
        }}
        actions={{
          // closeMessage: () => {
          //   setMessages(null);
          // },
          onUpdate: (uid) => onUpdate(uid),
          onDelete: (uid) => handleMultiDelete(uid),
        }}
      />
      <Footer />
    </>
  );
}
